module.exports = __webpack_public_path__ + "static/person-4-70x70-76c7e9c3a4879225919e8b2d4a76df0e.png";